const valuationForm = [
  {
    name: "brand",
    label: "Brand",
    type: "select",
    placeholder: "Select Brand",
    is_show: true,
    required: true,
    layout: "half",
    optionsSource: "brands",
  },
  {
    name: "model",
    label: "Model",
    type: "select",
    placeholder: "Select Model",
    is_show: true,
    required: true,
    layout: "half",
    optionsSource: "model",
    dependsOn: {
      field: "brand",
      parentSource: "brands",
      filterKey: "brand_id",
      waitMessageKey: "selectBrandFirst",
    },
  },
  {
    name: "year",
    label: "Manufacturing Year",
    type: "number",
    placeholder: "Enter year",
    is_show: true,
    required: true,
    layout: "half",
    min: 1990,
    max: 2030,
    step: 1,
  },
  {
    name: "km_driven",
    label: "KM Driven",
    type: "number",
    placeholder: "Total kilometres driven",
    is_show: true,
    required: true,
    layout: "half",
    min: 0,
    max: 9999999,
    step: 1,
    hint: "Higher KM typically lowers resale value",
  },
  {
    name: "fuel",
    label: "Fuel Type",
    type: "select",
    placeholder: "Select Fuel Type",
    is_show: true,
    required: true,
    layout: "half",
    optionsSource: "fuel_type",
  },
  {
    name: "transmission",
    label: "Transmission",
    type: "select",
    placeholder: "Select Transmission",
    is_show: true,
    required: true,
    layout: "half",
    optionsSource: "transmission",
  },
  {
    name: "tire_wear",
    label: "Tyre Condition",
    type: "select",
    placeholder: "Select Tyre Condition",
    is_show: true,
    required: true,
    layout: "half",
    hint: "Overall tyre wear affects estimated value",
    options: [
      { value: "5", label: "Excellent (Like New)" },
      { value: "15", label: "Good (Minimal Wear)" },
      { value: "30", label: "Fair (Moderate Wear)" },
      { value: "50", label: "Needs Replacement Soon" },
      { value: "75", label: "Poor (Heavy Wear)" },
    ],
  },
  {
    name: "state",
    label: "State",
    type: "select",
    placeholder: "Select State",
    is_show: true,
    required: false,
    layout: "half",
    optionsSource: "state",
    hint: "Optional — helps refine price for your region",
  },
];

export default valuationForm;
